import { Actions } from './indicateursActions';
import { Actions as UtilisateurCourantActions } from '../utilisateur/courantActions';

import { dateToddmmyyy } from 'utils/stringHelper';

var lastMonth = new Date();
lastMonth.setMonth(lastMonth.getMonth() - 1);

const initialState = {
    items: [],
    criteres: {
        dateCreationDebut: dateToddmmyyy(lastMonth),
        dateCreationFin: dateToddmmyyy(new Date())
    },
    isLoading: false,
    didInvalidate: false
};

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case Actions.FETCH_UTILISATEUR_INDICATEURS_REQUEST:
            return {
                ...state,
                isLoading: true,
                didInvalidate: false
            };
        case Actions.FETCH_UTILISATEUR_INDICATEURS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                didInvalidate: false,
                items: [...action.items]
            };
        case Actions.FETCH_UTILISATEUR_INDICATEURS_FAILURE:
            return {
                ...state,
                isLoading: false,
                didInvalidate: true,
                error: action.error
            };
        case Actions.INVALIDATE_UTILISATEUR_INDICATEURS:
            return {
                ...state,
                didInvalidate: true
            };
        // CRITERES DE RECHERCHE
        case Actions.UPDATE_CRITERES:
            {
                return {
                    ...state,
                    criteres: { ...initialState.criteres, ...action.criteres },
                    didInvalidate: true
                };
            }
        case UtilisateurCourantActions.LOGOUT:
            return { ...initialState };

        default:
    }

    return state;
};

export default reducer;